import { jsx as c, jsxs as A } from "react/jsx-runtime";
import { fpds as v, BREAKPOINTS as W } from "@fcamna/shared-component-foundations";
import { c as l } from "./index-65016bfa.mjs";
import { useState as I, useEffect as w, useRef as M } from "react";
import f, { css as d } from "styled-components";
import { u as N } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Button as x } from "./button.js";
import { u as E } from "./useWindowDimensions-ae69e913.mjs";
import { a as $ } from "./tslib.es6-59e1c9d8.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
function S(t, n) {
  var o;
  return typeof t == "string" ? n ? ((o = n[t]) !== null && o !== void 0 || (n[t] = document.querySelectorAll(t)), t = n[t]) : t = document.querySelectorAll(t) : t instanceof Element && (t = [t]), Array.from(t || []);
}
const y = {
  any: 0,
  all: 1
};
function k(t, n, { root: o, margin: r, amount: e = "any" } = {}) {
  if (typeof IntersectionObserver > "u")
    return () => {
    };
  const u = S(t), a = /* @__PURE__ */ new WeakMap(), T = (p) => {
    p.forEach((i) => {
      const s = a.get(i.target);
      if (i.isIntersecting !== !!s)
        if (i.isIntersecting) {
          const C = n(i);
          typeof C == "function" ? a.set(i.target, C) : m.unobserve(i.target);
        } else
          s && (s(i), a.delete(i.target));
    });
  }, m = new IntersectionObserver(T, {
    root: o,
    rootMargin: r,
    threshold: typeof e == "number" ? e : y[e]
  });
  return u.forEach((p) => m.observe(p)), () => m.disconnect();
}
function D(t, n) {
  var o = n === void 0 ? {} : n, r = o.root, e = o.margin, u = o.amount, a = o.once, T = a === void 0 ? !1 : a, m = $(I(!1), 2), p = m[0], i = m[1];
  return w(function() {
    var s;
    if (!(!t.current || T && p)) {
      var C = function() {
        return i(!0), T ? void 0 : function() {
          return i(!1);
        };
      }, g = {
        root: (s = r == null ? void 0 : r.current) !== null && s !== void 0 ? s : void 0,
        margin: e,
        amount: u === "some" ? "any" : u
      };
      return k(t.current, C, g);
    }
  }, [r, t, e, T]), p;
}
const _ = f.div`
  &.CTAButton-MainWrapper {
    ${({
  theme: {
    components: { ctaButton: t }
  }
}) => d(t.CTAMainWrapper)};
  }
`, V = f.div`
  &.CTAButton-DesktopWrapper {
    ${({
  theme: {
    components: { ctaButton: t }
  }
}) => d(t.CTADesktopWrapper)};
  }
`, O = f.div`
  &.CTAButton-MobileWrapper {
    ${({
  theme: {
    components: { ctaButton: t }
  }
}) => d(t.CTAMobileWrapper)};
  }
`, B = f.div`
  &.CTAButton-Title {
    ${({
  theme: {
    components: { ctaButton: t }
  }
}) => d(t.CTATitle)};
  }
`, b = f.div`
  &.CTAButton-ButtonWrapper {
    ${({
  theme: {
    components: { ctaButton: t }
  }
}) => d(t.CTAButtonWrapper)};
  }
`, q = f.button`
  @keyframes slide-in-out {
    0%,
    12%,
    100% {
      right: 100%;
    }
    6% {
      right: 0%;
    }
  }

  @keyframes textColorChange {
    0%,
    12%,
    100% {
      color: var(--animateTextFill, '${v.semantic.color.text.primaryStrong}');
    }
    6% {
      color: var(--animateTextDefault, '${v.semantic.color.text.onColor}');
    }
  }

  &.CTAButton-Btn-Contact {
    ${({
  theme: {
    components: { ctaButton: t }
  }
}) => d(t.CTAButtonContact)};
  }
`, h = ({
  contact: t,
  isMobile: n = !1,
  onClick: o
}) => {
  const r = M(null), e = D(r);
  return /* @__PURE__ */ c(
    q,
    {
      ref: r,
      $isMobile: n,
      onClick: o,
      className: l("CTAButton-Btn-Contact", { mobile: n }, { animate: e }),
      tabIndex: n ? 0 : -1,
      children: /* @__PURE__ */ c("span", { className: "contact", children: t })
    }
  );
}, nt = ({ titleText: t = "Software Sales Support:", className: n, onClick: o, contact: r, buttonProps: e }) => {
  const u = N({ label: "CTA Button" }), { width: a } = E();
  return /* @__PURE__ */ c(
    _,
    {
      className: l(["CTAButton-MainWrapper", n]),
      ...u,
      children: a > W.tabletMin ? /* @__PURE__ */ A(V, { className: l(["CTAButton-DesktopWrapper"]), children: [
        /* @__PURE__ */ c(B, { className: l(["CTAButton-Title"]), children: t }),
        /* @__PURE__ */ c(h, { contact: r })
      ] }) : /* @__PURE__ */ A(O, { className: l(["CTAButton-MobileWrapper"]), children: [
        /* @__PURE__ */ c(B, { className: l(["CTAButton-Title"]), children: t }),
        /* @__PURE__ */ A(b, { className: l(["CTAButton-ButtonWrapper"]), children: [
          /* @__PURE__ */ c(
            h,
            {
              contact: r,
              onClick: o,
              isMobile: !0
            }
          ),
          /* @__PURE__ */ c(
            x,
            {
              variant: "outline",
              onClick: o,
              leftIcon: e == null ? void 0 : e.leadingIcon,
              rightIcon: e == null ? void 0 : e.trailingIcon,
              children: (e == null ? void 0 : e.buttonText) || "Call Now"
            }
          )
        ] })
      ] })
    }
  );
};
export {
  nt as CTAButton
};
